import Dimens from "../../../../theme/dimens";
import useCommonStyles from "../../../../theme/use-common-styles";
import { useTheme } from "@mui/material";

/**
 * useStyles custom hook generates MUI theme dependent styles for the TelephonyTab component.
 * 
 * @returns An object containing the styled classes.
 */
const useStyles = () => {

	const theme = useTheme();
	const commonStyles = useCommonStyles();
	const { xxs, sm, md, base, lg, section } = Dimens.spacing;

	const styles = {
		wrapper: {
			display: 'flex',
			flex: 1,
			height: 'inherit'
		},
		innerWrapper: {
			flex: 1
		},
		container: {
			bgcolor: theme.palette.background.paper,
			height: 'inherit',
			display: 'flex',
			flex: 1,
			flexDirection: 'column'
		},
		content: {
			p: section,
			overflowY: 'auto',
			display: 'flex',
			flexDirection: 'column',
			'form >div.MuiStack-root': {
				minWidth: Dimens.inputMinWidth,
				[theme.breakpoints.down('sm')]: {
					minWidth: 'unset',
					flex: 1
				}
			},
			[theme.breakpoints.down('sm')]: {
				p: lg
			}
		},
		whiteListform: {
			flexDirection: 'row',
			display: 'flex',
			alignItems: 'start'
		},
		btnWrapper: {
			pl: lg
		},
		chipWrapper: {
			...commonStyles.noScrollBar,
			overflowY: 'auto',
			p: 0
		},
		chip: {
			m: `${xxs} ${lg} ${md} 0`,
			borderRadius: Dimens.radius.md,
			p: `${sm} ${lg}`,
			height: 'auto',
			bgcolor: theme.palette.background.default,
			'.MuiChip-label': {
				...theme.typography.p1,
				...commonStyles.textEllipsis(1),
				whiteSpace: 'normal',
				p: 0
			},
			'.MuiChip-deleteIcon': {
				display: 'flex',
				m: 0,
				ml: base,
				fontSize: Dimens.icon.sm,
				color: theme.palette.text.primary,
				'&:hover': {
					color: theme.palette.text.primary
				}
			}
		},
		form: {
			flex: 1,
			justifyContent: 'space-between',
			display: 'flex',
			flexDirection: 'column',
			overflow: 'hidden'
		},
		formContent: {
			display: 'flex',
			flexDirection: 'column',
			overflowY: 'auto',
			flex: 1
		},
		callOptionsRow: {
			display: 'flex',
			flexDirection: {
				xs: 'column',
				sm: 'row'
			},
			flex: 1,
			gap: {
				xs: Dimens.spacing.xxs,
				sm: md
			}
		},
		callOption: {
			display: 'flex',
			flexDirection: 'row',
			flex: 1
		},
		phoneBox: {
			display: 'flex',
			flexDirection: 'row',
			width: '100%'
		},
		codeBox: {
			width: Dimens.countryCodeBoxMinWidth,
			flexShrink: 0
		}
	};

	return styles;
};

export default useStyles;